const API_URL = process.env.REACT_APP_API_URL;

let apiUrls = {
    elements: `${API_URL}/cert-mail-elements`,
    saveDiscountTable: `${API_URL}/cert-mail-element/save-discount-table`
};

export default apiUrls;
